import "core-js/modules/es6.object.define-property";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { setTrk, TrkTag } from '@nerdwallet/nw-client-lib/trk-helper';
/** Helper method to construct a url w/ tracking parameters
 *
 * @param                    Object
 *  @key url                 string  base link
 *  @key trkElement          string  TrkElement from @nerdwallet/nw-client-lib/trk-helper
 *  @key trkPageType         string  TrkPageType from @nerdwallet/nw-client-lib/trk-helper
 *  @key trkLocation         string  slug representing the location of the referrer
 *  @key trkSectionCategory  string  slug representing the page section context of the referrer
 *  @key trkTaxonomy         Object  window.nwPageTaxonomy obj
 *
 * @return                string  url w/ tracking data as query params
 */

export var buildLink = function buildLink(_ref) {
  var _params;

  var url = _ref.url,
      trkElement = _ref.trkElement,
      trkPageType = _ref.trkPageType,
      trkLocation = _ref.trkLocation,
      trkSectionCategory = _ref.trkSectionCategory,
      trkTaxonomy = _ref.trkTaxonomy;
  return setTrk({
    url: url,
    taxonomy: trkTaxonomy,
    params: (_params = {}, _defineProperty(_params, TrkTag.location, trkLocation), _defineProperty(_params, TrkTag.element, trkElement), _defineProperty(_params, TrkTag.pageType, trkPageType), _defineProperty(_params, TrkTag.sectionCategory, trkSectionCategory), _params)
  });
};